export default "__VITE_ASSET__36eC9CLv__"